import { render, staticRenderFns } from "./WebHostingDomain.vue?vue&type=template&id=5c3a188c&scoped=true&"
import script from "./WebHostingDomain.vue?vue&type=script&lang=js&"
export * from "./WebHostingDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a188c",
  null
  
)

export default component.exports